export const generic_errors = {
    'es':{
        INCOMPLETE_FORM:'Llene los campos faltantes'
    }
    
}